import { TaskCompletionStatusEnum } from '@application/enums/task-completion-status-enum';
import { alpha, useTheme } from '@mui/material';
import { centeredRowStack } from '@ui/style/style';
import { useMemo } from 'react';
const useHeadingBarStyles = (type = TaskCompletionStatusEnum.New, action = false) => {
    const theme = useTheme();
    const colors = useMemo(() => {
        switch (type) {
            case TaskCompletionStatusEnum.New:
                return {
                    bgcolor: alpha(theme.palette.grey[800], 0.08),
                    indicatorColor: theme.palette.text.primary,
                    headingColor: theme.palette.text.primary
                };
            case TaskCompletionStatusEnum.InProgress:
                return {
                    bgcolor: alpha(theme.palette.primary.main, 0.08),
                    indicatorColor: theme.palette.primary.main,
                    headingColor: theme.palette.primary.main
                };
            case TaskCompletionStatusEnum.Completed:
                return {
                    bgcolor: alpha(theme.palette.success.main, 0.08),
                    indicatorColor: theme.palette.success.main,
                    headingColor: theme.palette.success.main
                };
            default:
                return {
                    bgcolor: alpha(theme.palette.background.paper, 0.92),
                    badgebgcolor: '#F5F5F5',
                    badgetextcolor: '#F5F5F5',
                    headingColor: '#F5F5F5'
                };
        }
    }, [
        theme.palette.background.default,
        theme.palette.common.white,
        theme.palette.grey,
        theme.palette.info.contrastText,
        theme.palette.info.main,
        theme.palette.success.contrastText,
        theme.palette.success.main,
        type
    ]);
    const { indicatorColor, bgcolor, headingColor } = colors;
    return {
        mainBarContainer: {
            ...centeredRowStack,
            bgcolor: bgcolor,
            borderRadius: (theme) => theme.spacing(1.5),
            px: (theme) => theme.spacing(1.5),
            py: (theme) => theme.spacing(1),
            justifyContent: 'center',
            gap: 1,
            mb: 1.5,
            position: 'sticky',
            top: 8,
            zIndex: 1000
        },
        indicator: {
            width: '14px',
            height: '14px',
            bgcolor: indicatorColor,
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        titles: {
            color: headingColor
        }
    };
};
export default useHeadingBarStyles;
